module.exports = __webpack_public_path__ + "img/icon-vk.50174a25.svg";